import { parseVercelJson } from '../runner/parse-vercel-json.js'

/**
 * Payload shape: `{"status":"action_required","reason":"missing_scope","choices":[{name}]}`.
 * Team-first accounts name the personal team `<username>s-projects`, and the CLI lists the default
 * scope first.
 */
export function resolveMissingScopeChoice(output: string, preferred?: string): string | undefined {
  if (!/missing_scope/.test(output)) return undefined

  const payload = parseVercelJson<{ reason?: string; choices?: Array<{ name?: string }> }>(output)
  if (payload?.reason !== 'missing_scope') return undefined

  const names = (payload.choices ?? [])
    .map((choice) => choice.name)
    .filter((name): name is string => typeof name === 'string' && name.length > 0)
  if (names.length === 0) return undefined
  if (names.length === 1) return names[0]

  if (preferred) {
    const match = names.find((name) => name === preferred || name.startsWith(preferred))
    if (match) return match
  }
  return names[0]
}
